/**
 * components
 */
const select2 = require('select2');
const moment = require('moment');
const daterangepicker = require('daterangepicker');
const M = require('materialize-css');

import Vue from "vue/dist/vue.esm.js";
import Modal from "./modal.js";

export default class {

	constructor() {
		moment.locale("ja");
	}

	/**
	 * form::select(select2)
	 */
	selectBox(selector, onselect) {
		if(!$(selector).length) return false;

		$(selector).select2({ minimumResultsForSearch: Infinity });
		if(!onselect) return;

		$(selector).off('select2:select');
		$(selector).on('select2:select', onselect);
	}

	/**
	 * datepicker::range
	 */
	calendar(selector, onchange, minDate, maxDate) {
		if(!onchange) onchange = function() { return true };
		$(selector).daterangepicker({
			locale: {
				format: 'YYYY/MM/DD',
				daysOfWeek: [ "日", "月", "火", "水", " 木", "金", "土" ],
				firstDay: 1,
				applyLabel: 'OK',
				cancelLabel: 'キャンセル'
			},
      minDate: minDate,
      maxDate: maxDate
    }, onchange);
	}

	/**
	 * datepicker::single
	 */
	datepicker(selector, onchange) {
		if(!onchange) onchange = function() { return true };
		$(selector).daterangepicker({
			locale: {
				format: 'YYYY/MM/DD',
				daysOfWeek: [ "日", "月", "火", "水", " 木", "金", "土" ],
				firstDay: 1,
				applyLabel: 'OK',
				cancelLabel: 'キャンセル'
			},
			singleDatePicker: true,
			autoUpdateInput: false
		}, onchange);
		$(selector).on('apply.daterangepicker', function(ev, picker) {
			$(this).val(picker.startDate.format('YYYY/MM/DD'));
		});
		$(selector).on('cancel.daterangepicker', function(ev, picker) {
			$(this).val('');
		});
	}

	/**
	 * timepicker
	 */
	timepicker(selector, onchange) {
		if(!onchange) onchange = function() { return true };
		$(selector).timepicker({});
	}

	/**
	 * タブ
	 */
	tabs(selector) {
		$(selector).each(function(i, e) { M.Tabs.init(e) });
	}

	/**
	 * modal（白黒共通）
	 */
	modal(btn, close) {
		return new Modal(btn, close);
	}

	/**
	 * スマホヘッダナビ
	 */
	sphnav(selector) {
		$(selector).collapsible(); // SP
	}

	/**
	 * グローバルナビ
	 */
	gnav(selector) {
		if(!$(selector).length) return false;

		return new Vue({
			el: selector,
			data () {
				return {
					isGnavOpened: false,
					categoryNum: 0,
					isSP: (function() {
						var mql = window.matchMedia("(min-width: 992px)");
						return mql.matches ? false : true;
					})()
				}
			},
			mounted: function(){},
			methods: {
				isCategorySelect: function(num,event) {
					let currentNum = this.categoryNum;
					this.setIsSP();

					if(event.type == "mouseenter") {
						if(this.isSP) return false;
						this.categoryNum = currentNum == num ? 0 : num;
						this.isGnavOpened = currentNum == num ? true : false;
						return false;
					}

					if(!this.isSP) return false;
					this.categoryNum = currentNum == num ? 0 : num;
					this.isGnavOpened = currentNum == num ? true : false;
				},
				isGnavClose: function(event) {
					this.setIsSP();
					if(!this.isSP || event.type == "click") {
						//PC
						this.categoryNum = 0;
						this.isGnavOpened = false;
					}
				},
				setIsSP: function() {
					var mql = window.matchMedia("(min-width: 992px)");
					this.isSP = mql.matches ? false : true;
				}
			}
		});
	}

	/**
	 * ページ下部ナビ
	 */
	bottomNav() {
		if($('.c-button-nav').length) $('.l-main').addClass('l-main--has-bottom-nav');
		if($('.c-nav').length) $('.l-main').addClass('l-main--has-top-nav');
	}

	/**
	 * smoothLink
	 */
	smoothLink() {
		$('a.js-anchor[href^="#"]').on('click', function() {
			var href = $(this).attr("href"),
				target = $(href == "#" || href == "#top" ? 'html' : href),
				speed = href == "#top" ? 800 : 400,
				fixedH = ($(".l-header").css('position') === 'fixed') ? document.querySelector('.l-header').scrollHeight : 0,
				position = target.offset().top - fixedH;
			$('body,html').animate({ scrollTop: position }, speed, 'swing');
			return false;
		});
	}

	/**
	 * メッセージ（赤）
	 */
	messageCaution(msg, close) {
		if($('#msgview').length) $('#msgview').remove();
		if(close) return;

		var msgv = $('<div id="msgview" class="mv-red">' +msg+ '</div>');
		$('body').append(msgv);

		msgv.ready(function() {
			$('#msgview').slideDown('fast', function(){ setTimeout(function(){ $(this).slideUp('fast') }.bind(this), 1700) });
		});
	}

	/**
	 * メッセージ（青）
	 */
	messageDone(msg, close) {
		if(close) {
			$('#msgview').slideUp('normal', function(){ $(this).remove(); });
			return;
		}
		if($('#msgview').length) $('#msgview').remove();

		var msgv = $('<div id="msgview" class="mv-blue">' +msg+ '</div>');
		$('body').append(msgv);
		msgv.ready(function(){
			$('#msgview').slideDown('fast');
		});
	}

	/**
	 * エラーメッセージ
	 */
	messageError(msg, hide) {
		if(hide) {
			$('.error-msg').hide();
			return false;
		}
		$('.error-msg').show();
		$('.error-msg').find('div').html(msg.join('<br>'));
	}

	/**
	 * グラフ読み込み中のオーバーレイ
	 */
	working(target, message, close) {
		if(close) {
			$(target).find('.loading-overlay-bg').remove();
			return;
		}

		message = message ?? 'Loading';
		$(target).css('position','relative');

		$(target).each(function() {
			if($(this).find('.loading-overlay-bg').length) return;
			$(this).append('<div class="loading-overlay-bg"><div class="ol-inner"><div class="ol-circle"></div></div></div>');
		});
	}

	/**
	 * loading
	 */
	loading(message, close) {
		$('#overlay-bg,#loading').fadeOut('fast', function() {
			$(this).remove();
			$('.l-gnav-list').show(); // ナビボタン
		});
		if(close) return true;

		message = message ?? 'Loading';
		$('.l-gnav-list').hide(); // ナビボタン

		$('body').append([
			'<div id="overlay-bg"></div>',
			'<div id="loading">',
			'<div class="sk-cube-grid"><div class="sk-cube sk-cube1"></div><div class="sk-cube sk-cube2"></div><div class="sk-cube sk-cube3"></div><div class="sk-cube sk-cube4"></div>',
			'<div class="sk-cube sk-cube5"></div><div class="sk-cube sk-cube6"></div><div class="sk-cube sk-cube7"></div><div class="sk-cube sk-cube8"></div><div class="sk-cube sk-cube9"></div></div>',
			'<p>' +message+ '</p>',
			'</div>'
		].join(''));
		$('#overlay-bg,#loading').fadeIn('fast');
		return true;
	}
}
